import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { FaCrown, FaRegUser, FaRegCreditCard } from "react-icons/fa";
import { MdSubscriptions, MdOutlineKeyboardArrowRight, MdNotifications, MdOutlineHelpOutline } from "react-icons/md";
import { HiPlusCircle } from "react-icons/hi";
import { RiLogoutCircleRLine } from "react-icons/ri";

import { SetShowLocationPromptOverlay, SetVPTStatus, SetModalProperties, ShowModal, SetLocation, CheckLocationEligibility } from "../../../redux/v2/utils/actions";
import { AddUserLocation } from "../../../redux/v2/user/actions";
import { clearLocalStorage } from "../../../utils/localstorage";
import { callSocket } from "../../../utils/socket";

import useSVG from "../../../hooks/useSVG";
import useVPTLocation from "../../../hooks/useVPTLocation";

import "./styles.css";

function MobileNavV2(props) {
    const navigate = useNavigate();

    const { billing, account } = props.User;
    const { vptStatus, location } = props.Utils;

    const { UseMenuSVG } = useSVG();
    const { initVPT } = useVPTLocation({
        location: location,
        vptStatus: vptStatus,
        SetVPTStatus: props.SetVPTStatus,
        SetModalProperties: props.SetModalProperties,
        ShowModal: props.ShowModal,
        onClickCloseButton: props.onClickCloseButton,
        AddUserLocation: props.AddUserLocation,
        SetLocation: props.SetLocation,
        CheckLocationEligibility: props.CheckLocationEligibility,
    });

    const platform = localStorage.getItem("indi-platform");
    const isUsingApp = platform && (platform === "ios-app" || platform === "android-app");

    const menuBehavior = (component) => {
        props.onClickCloseButton();
        if (!isUsingApp) {
            //if web
            navigate("/account", {
                state: { selectedComponent: component },
            });
        } else {
            if (account?.subscription?.in_app_transaction_details) {
                //if with inapp details
                callSocket("/open-mobile-account-page", { selectedComponent: component });
            } else {
                navigate("/account", {
                    state: { selectedComponent: component },
                });
            }
        }
    };
    const inPromo = (account?.billingInfo?.currentPlan?.code == "promo" && !account?.billingInfo?.pendingChange?.plan?.code);

    return (
        <>
            <div className="nav-menu-group-links">
                <p>Account Settings</p>
                <div className="nav-menu-group-links-items">
                    <div
                        className="nav-menu-group-link"
                        onClick={() => {
                            menuBehavior("PROFILE");
                        }}
                    >
                        <div>
                            <FaRegUser />
                            <span>Profile</span>
                        </div>
                        <div>
                            <MdOutlineKeyboardArrowRight />
                        </div>
                    </div>

                    {!account?.subscription?.in_app_transaction_details && !inPromo && (
                        <div
                            className="nav-menu-group-link"
                            onClick={() => {
                                menuBehavior("BILLING");
                            }}
                        >
                            <div>
                                <FaRegCreditCard />
                                <span>Billing</span>
                            </div>
                            <div>
                                <MdOutlineKeyboardArrowRight />
                            </div>
                        </div>
                    )}

                    {!account?.user?.company && (
                        <div
                            className="nav-menu-group-link"
                            onClick={() => {
                                menuBehavior("SUBSCRIPTION");
                            }}
                        >
                            <div>
                                <MdSubscriptions />
                                <span>Plan</span>
                            </div>
                            <div>
                                <MdOutlineKeyboardArrowRight />
                            </div>
                        </div>
                    )}

                    {isUsingApp && (
                        <div
                            className="nav-menu-group-link"
                            onClick={() => {
                                props.onClickCloseButton();
                                navigate("/settings/notification");
                            }}
                        >
                            <div>
                                <MdNotifications />
                                <span>Notifications</span>
                            </div>
                            <div>
                                <MdOutlineKeyboardArrowRight />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="nav-menu-group-links">
                <p>Connect</p>
                <div className="nav-menu-group-links-items">
                    <div
                        className="nav-menu-group-link"
                        onClick={() => {
                            initVPT();
                            // navigate("/virtual-pt");
                        }}
                    >
                        <div>
                            {UseMenuSVG("heart")}
                            <span>Ask a Physical Therapist</span>
                        </div>
                        <div>
                            <MdOutlineKeyboardArrowRight />
                        </div>
                    </div>
                </div>
            </div>

            {((account?.user?.company && !account?.user?.parent_user) || account?.user?.therapist_id) && (<div className="nav-menu-group-links">
                <p>Refer a Friend</p>
                <div className="nav-menu-group-links-items">
                    {/* {account?.user?.company && !account?.user?.parent_user && (
                        <div
                            className="nav-menu-group-link"
                            onClick={() => {
                                props.onClickCloseButton();
                                navigate("/plus-one");
                            }}
                        >
                            <div>
                                <HiPlusCircle />
                                <span>Add Your +1</span>
                            </div>
                            <div>
                                <MdOutlineKeyboardArrowRight />
                            </div>
                        </div>
                    )} */}

                    {account?.user?.therapist_id && (
                        <div
                            className="nav-menu-group-link"
                            onClick={() => {
                                props.onClickCloseButton();
                                navigate("/patient-invite");
                            }}
                        >
                            <div>
                                <FaCrown />
                                <span>Patient Discharge</span>
                            </div>
                            <div>
                                <MdOutlineKeyboardArrowRight />
                            </div>
                        </div>
                    )}
                </div>
            </div>)}

            <div className="nav-menu-group-links">
                <p>Support</p>
                <div className="nav-menu-group-links-items">
                    <div
                        className="nav-menu-group-link"
                        onClick={() => {
                            props.onClickCloseButton();
                            navigate("/indi-support");
                        }}
                    >
                        <div>
                            <MdOutlineHelpOutline />
                            <span>Get Help</span>
                        </div>
                        <div>
                            <MdOutlineKeyboardArrowRight />
                        </div>
                    </div>
                    <div
                        className="nav-menu-group-link"
                        onClick={() => {
                            props.onClickCloseButton();

                            if (!isUsingApp) {
                                navigate("/login");
                                // window.location.href = "/login";
                            } else {
                                callSocket(`logout-mobile`);
                            }
                            clearLocalStorage();
                        }}
                    >
                        <div>
                            <RiLogoutCircleRLine />
                            <span>Logout</span>
                        </div>
                        <div>
                            <MdOutlineKeyboardArrowRight />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Utils: state.Utils,
});
export default connect(mapStateToProps, {
    SetShowLocationPromptOverlay,
    SetVPTStatus,
    SetModalProperties,
    ShowModal,
    AddUserLocation,
    CheckLocationEligibility,
    SetLocation,
})(MobileNavV2);
